module.exports = __webpack_public_path__ + "static/media/serviceI-old.377e507a.jpg";